import { useState } from 'react';
import { headTableCell } from 'containers/pages/users/data';
import { useSelector } from 'react-redux';
import { selectAllSearchedUsers } from 'redux/userMgt/userMgtSlice';

/**
 * @function useUserList
 * @returns {object}
 */
function useUserList() {
	const users = useSelector(selectAllSearchedUsers);

	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('');
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(true);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [selectedIds, setSelectedIds] = useState([]);

	const onSort = (property) => (e) => {
		onRequestSort(e, property);
	};

	const onDense = (e) => {
		setDense(!dense);
	};

	const onPage = (e, newPage) => {
		setPage(parseInt(newPage));
	};

	const onResetSelectedIds = () => {
		setSelectedIds([]);
	};

	const onRequestSort = (e, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const onRowsPerPage = (e) => {
		setRowsPerPage(parseInt(e.target.value, 10));
		setPage(0);
	};

	const onForm = (id) => {
		if (selectedIds.includes(id)) {
			const filteredSelectedIds = selectedIds.filter(
				(selectedId) => selectedId !== id,
			);
			setSelectedIds(filteredSelectedIds);
		} else {
			setSelectedIds([...selectedIds, id]);
		}
	};

	const state = {
		users,
		headTableCell,
		order,
		orderBy,
		page,
		dense,
		rowsPerPage,
		selectedIds,
	};

	const handler = {
		onSort,
		onForm,
		onRowsPerPage,
		onPage,
		onDense,
		onResetSelectedIds,
	};

	return { state, handler };
}

export default useUserList;
